import React from "react";
// import { Beaker, Target, BarChart3, Users, Award } from "tabler-icons-react";
import {
  Award,
  Users,
  Settings,
  Target,
  BarChart3,
  ChartBar,
  Beaker,
  Flask,
} from "tabler-icons-react";
export default function Research() {
  return (
    <div>
      <div className="text-center mb-12">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          Research & Development
        </h3>
        <p className="text-lg text-gray-600">
          Advancing dairy technology through continuous research and innovation
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8 mb-12">
        <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-cyan-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <Flask className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Current Research Projects
          </h4>
          <div className="space-y-4">
            <div className="bg-white p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                AI-Powered Milk Somatic Cell Counter
              </h5>
              <p className="text-sm text-gray-600">
                Developing machine learning algorithms to count Somatic Cells
                Present in milk
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                IoT-Enabled Smart Dairy Management
              </h5>
              <p className="text-sm text-gray-600">
                Creating integrated IoT solutions for comprehensive dairy farm
                monitoring and automation.
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                Portable Testing Solutions
              </h5>
              <p className="text-sm text-gray-600">
                Developing ultra-portable milk analyzers for remote and mobile
                testing applications.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-amber-50 to-amber-100 p-8 rounded-2xl hover:shadow-lg transition-shadow">
          <div className="bg-amber-500 p-4 rounded-full w-16 h-16 mb-6 flex items-center justify-center">
            <Target className="w-8 h-8 text-white" />
          </div>
          <h4 className="text-xl font-bold text-gray-900 mb-4">
            Research Focus Areas
          </h4>
          <div className="space-y-4">
            <div className="bg-white p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                Precision Agriculture
              </h5>
              <p className="text-sm text-gray-600">
                Integrating milk quality data with farm management systems for
                optimized dairy operations.
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                Sustainability Solutions
              </h5>
              <p className="text-sm text-gray-600">
                Developing eco-friendly technologies that reduce environmental
                impact of dairy operations.
              </p>
            </div>
            <div className="bg-white p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                Cost-Effective Innovation
              </h5>
              <p className="text-sm text-gray-600">
                Creating affordable solutions accessible to small-scale dairy
                farmers and cooperatives.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-8">
        <div className="text-center">
          <div className="bg-blue-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            {/* <BarChart3 className="w-10 h-10 text-blue-600" /> */}
            <ChartBar className="w-8 h-8 text-blue-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            15+ Active Projects
          </h5>
          <p className="text-gray-600">
            Ongoing research initiatives across multiple domains
          </p>
        </div>
        <div className="text-center">
          <div className="bg-green-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <Users className="w-10 h-10 text-green-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            3+ Researchers
          </h5>
          <p className="text-gray-600">
            Dedicated team of Developers and engineers
          </p>
        </div>
        <div className="text-center">
          <div className="bg-purple-100 p-6 rounded-full w-20 h-20 mx-auto mb-4 flex items-center justify-center">
            <Award className="w-10 h-10 text-purple-600" />
          </div>
          <h5 className="text-lg font-semibold text-gray-900 mb-2">
            2+ Patents
          </h5>
          <p className="text-gray-600">
            Intellectual property in dairy technology
          </p>
        </div>
      </div>
    </div>
  );
}
